<template>
  <div v-if="label" class="custom-tag">
    <el-tag :type="value" :effect="effect" size="small">
      {{ label }}
    </el-tag>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: '' },
    effect: { type: String, default: 'dark' },
  },
}
</script>

<style lang="scss" scoped>
.custom-tag {
  .el-tag {
    border: none;
  }
  .el-tag--N {
    color: #464646;
    background-color: #dce2eb;
  }
  .el-tag--T {
    color: #ffffff;
    background-color: #0089c3;
  }
  .el-tag--P {
    color: #ffffff;
    background-color: #0046f6;
  }
  .el-tag--R {
    color: #ffffff;
    background-color: #e99145;
  }
  .el-tag--F {
    color: #ffffff;
    background-color: #1b9c44;
  }
  .el-tag--D {
    color: #ffffff;
    background-color: #f85c7c;
  }
  .el-tag--C {
    color: #ffffff;
    background-color: #e99d42;
  }
}
</style>
